import 'bootstrap'
import 'jquery.easing';
import 'svgxuse'
import './plugins/scrollevent'
import init from './module/init';
import HOME from './page/home';
import FEATURES from './page/features';

const [w,d,l] = [window,document,location]

init()

switch(l.pathname){
  case '/': HOME(); break
  case '/nursery/': FEATURES(); break
  case '/primary/': FEATURES(); break
  case '/juniorhigh/': FEATURES(); break
  case '/pke/': FEATURES(); break
}